module.exports = __webpack_public_path__ + "6f6177da0d2b73d21182980aabefd2de.MP3";